function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.99747 -4.2317e-07C4.17479 -4.2317e-07 4.35719 0.0780839 4.47878 0.208224L7.79227 3.6127C7.93414 3.75846 8 3.92504 8 4.09162C8 4.47683 7.73148 4.74753 7.38189 4.74753C7.18936 4.74753 7.03737 4.66424 6.91577 4.54451L5.76061 3.36283L4.58518 2.04581L4.64598 3.21707V9.31286C4.64598 9.7241 4.38252 10 3.99747 10C3.61241 10 3.34895 9.7241 3.34895 9.31286V3.21707L3.41482 2.04581L2.23433 3.36283L1.08423 4.54451C0.962635 4.66424 0.81064 4.74753 0.618113 4.74753C0.263458 4.74753 -7.9046e-08 4.47683 -7.9046e-08 4.09162C-7.9046e-08 3.92504 0.0658644 3.76366 0.20266 3.62311L3.51615 0.208224C3.64281 0.0780839 3.82014 -4.2317e-07 3.99747 -4.2317e-07Z",
  fill: "white"
});

function SvgIconArrowUpThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUpThin);
export default __webpack_public_path__ + "static/media/icon-arrow-up-thin.aea393df.svg";
export { ForwardRef as ReactComponent };